<template>
  <div
    class="w-full pt-[78px] desktop:pt-[94px] tablet-h:pt-10 tablet-v:pt-[111px] text-[26px] leading-[36px] text-gray-800 font-secondary font-[370] text-center flex flex-col items-center px-6"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="max-w-[350px] tablet-v:w-full mx-auto mb-5">
        <span class="text-green-700 font-semibold">
          Your opportunities could be ruined
        </span>
        when someone uses or takes ownership of your work because it was
        <span class="text-green-700 font-semibold"> not protected. </span>
      </div>

      <div class="mt-auto w-full">
        <TestimonialCard
          :quote="testimonial.quote"
          :author="testimonial.author"
          class="mb-[30px]"
        />

        <UiButton class="w-full" primary large @click="handleClick">
          Next
        </UiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import TestimonialCard from '@/shared/components/TestimonialCard.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useRouter } from 'vue-router'
import ArizonaAvatar from '@/assets/images/Arizona-Avatar.jpg'
import { analytics } from '@/shared/services/analytics'
import { useWebviewStore } from '@/shared/stores/webview'

const testimonial = {
  quote:
    "For me, to have something that I can protect my work right away before I send it out. That's a game changer.",
  author: {
    avatarUrl: ArizonaAvatar,
    name: 'Arizona Slim Beats',
    title: 'Producer, Fame Productions',
  },
}

const { mutate: completeStep } = useCompleteStepMutation()

const router = useRouter()
const webviewStore = useWebviewStore()

const handleClick = () => {
  completeStep({
    step: 12,
  })

  analytics.track('onboarding_step_completed', {
    step: 12,
    source: webviewStore.isActive
      ? webviewStore.isiOS
        ? 'apple'
        : 'google'
      : 'web',
  })

  router.push('/onboarding/pro')
}
</script>
